import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import style from './style.module.scss';

const Table = ({ reduced, className, children }) => (
  <table
    className={cx(
      style.table,
      {
        [style.reduced]: reduced,
      },
      className
    )}
  >
    {children}
  </table>
);

Table.propTypes = {
  children: PropTypes.any,
  reduced: PropTypes.bool,
  className: PropTypes.string,
};

export default Table;
